module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet_6.a38ec004.jpg";